<template lang="pug">
  .nearby-location.text-left.mt-10.mb-10
    .top-wrap
      .location-description.pr-10
        p.mini-tag.upper.xs-f-xxsmall.max-at-tweak.brand-color-2(v-if="location.isMiniBar") Madison Reed Mini Bar
        p.mini-tag.upper.xs-f-xxsmall.max-at-tweak.brand-color-2(v-else-if="!location.hasOpened && location.openingDate") Opens {{ $formatDate(location.openingDate, 'MMMM YYYY') }}
        p.mini-tag.upper.xs-f-xxsmall.max-at-tweak.brand-color-2(v-else-if="!location.hasOpened") Coming soon

        .colorbar-name.mt-10.mb-10
          a.standalone.xs-f-xsmall.max-at-tweak(:href="titleNameCta" @click="trackMREvent('HCB Locations page - HCB title clicked')") {{ location.name }}

        p.xs-f-xsmall.max-at-tweak {{ location.shortAddress }}
        a.xs-f-xsmall.max-at-tweak.underline(@click="trackMREvent('HCB Locations page - view details clicked')" :href="`/colorbar/locations/${location.code}`") View Details

      .image-wrap.a-box-xs-4x3
        .a-box-content
          ImgBox(:media-obj="location.headerImage")

    .bottom-wrap.pt-50m
      p.brand-color-1.upper.xs-f-xxsmall.max-at-tweak visit us for
      ul.visit-list.xs-f-xsmall.max-at-tweak
        li(v-if="!location.isMiniBar")
          MrIcon(name="chair" height="1.25em" :fill="false")
          | &nbsp;Services
        li
          MrIcon(name="chat" height="1.25em" :fill="false")
          | &nbsp;Free Consultation
        li
          MrIcon(name="shampoo-and-conditioner" height="1.25em" :fill="false")
          | &nbsp;Retail

    .ctas.text-center.pt-100m
      a.mr-btn.btn-inverse.btn-block.xs-f-xsmall.max-at-tweak(v-if="location.isMiniBar" :href="location.mapURL" rel="noopener noreferrer" ) get directions
      a.mr-btn.btn-inverse.btn-block.xs-f-xsmall.max-at-tweak(
        v-else
        :href="`/colorbar/booking/${location.code}/services`"
        @click="onCtaClicked"
      ) {{location.hasOpened ? 'book a service' : 'pre-book now'}}

</template>

<script>
  import ImgBox from '@components/imgBox';
  import MrIcon from '@components/MrIcon';

  export default {
    name: 'NearbyLocation',

    components: {
      ImgBox,
      MrIcon,
    },

    props: {
      location: {
        type: Object,
        required: true,
      },
    },

    computed: {
      titleNameCta() {
        return `/colorbar/booking/${this.location.code}/services`;
      }

    },

    methods: {
      onCtaClicked() {
        this.trackEvent(`Book Service CTA Clicked`, {
          locationCode: this.location.code,
          locationName: this.location.name,
        });
      },
    },
  };
</script>

<style lang="stylus">
  .nearby-location
    display inline-block
    vertical-align top
    width 100%
    border 1px solid ui-color-5
    border-radius 0.5em
    padding 0.75em 1em

    .top-wrap
      min-height 8em
      display flex
      flex-direction row
      justify-content space-between

    .location-description
    .image-wrap
      display inline-block
      vertical-align top

    .image-wrap
      width 8em
      min-width 8em
      max-width 8em

    .mini-tag
      background-color ui-color-3
      display inline-block
      padding 0.25em 0.5em
      border-radius 0.15em

    .bottom-wrap
      .visit-list
        li
          display inline-block
          vertical-align top
          margin-right 1em

        .mr-icon
          margin-top -0.12em
          
  @media mq-mobile
    .location-section
      width 20.5em
      padding 0.75em

      .image-wrap
        width 7em
        min-width 7em
        max-width 7em

      .bottom-wrap
        .visit-list
          li
            margin-right 0.5em
</style>